<div class="menu">
  <div class="logo">
    <div class="first"></div>
    <div class="second">
      <i class="pi pi-box"></i>
    </div>
    <div class="third"></div>
  </div>
</div>
<div class="login">
  <h1>{{ environment.softwareName }}</h1>
  <h3 class="text-center m-0">Password dimenticata</h3>
  <p-messages
    [(value)]="msgs"
    [enableService]="false"></p-messages>

  <form
    *ngIf="!sent"
    [formGroup]="frm"
    (ngSubmit)="submit()"
    class="w-full">
    <div class="flex flex-column gap-2 justify-content-center align-items-stretch">
      <p class="text-center m-0">
        Inserisci l'email del tuo account: ti invieremo un link per scegliere una nuova password.
      </p>
      <div>
        <span class="p-float-label">
          <input
            pInputText
            id="email"
            type="email"
            autocomplete="email"
            formControlName="email" />
          <label htmlFor="email">Email</label>
        </span>
        <small
          class="p-error"
          *ngIf="frm.get('email')?.errors && frm.get('email')?.dirty"
          >Inserisci un'email valida.</small
        >
      </div>
      <div class="mx-auto w-3">
        <p-button
          styleClass="butt w-full"
          type="submit"
          [disabled]="frm.invalid"
          [loading]="loading"
          label="Invia link"
          [rounded]="true" />
      </div>
    </div>
  </form>

  <div
    *ngIf="sent"
    class="w-full">
    <p class="text-center m-0">
      Se esiste un account con questa email, ti abbiamo inviato le istruzioni. Il link è valido per
      10 minuti.
    </p>
  </div>

  <div class="mx-auto">
    <a routerLink="/login">Torna al login</a>
  </div>
</div>
